import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

import styles from "./styles.module.scss";

// component
import Form from "../Form";

// assets
import CloseIcon from "src/assets/images/home/close.svg";

const MobFiler = ({ showForm, setShowForm }) => {
  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleResize = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <AnimatePresence>
      {showForm && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={styles.mob__filter__wrapper}
        >
          <motion.img
            initial={{ y: 80 }}
            animate={{ y: 0 }}
            transition={{ delay: 0.2, duration: 0.25 }}
            className={styles.close__icon}
            src={CloseIcon}
            alt="close"
            onClick={handleClose}
          />
          <Form setShowForm={setShowForm} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobFiler;
